import { Injectable } from '@angular/core';
import { STATES } from 'app/store/models/register.model';
import { ISelectItem } from '../models/select.model';

@Injectable()
export class UtilitiesService {
  getStateName(stateCode: string): string {
    const targetItem = STATES.filter(item => item[1] === stateCode);

    return targetItem.length === 1 ? targetItem[0][0] : '';
  }

  getMomentTimezone(timezone: string): string {
    switch (timezone) {
      case 'Eastern Time (US & Canada)':
        return 'US/Eastern';
      case 'Alaska':
        return 'US/Alaska';
      case 'Hawaii':
        return 'US/Hawaii';
      case 'Pacific Time (US & Canada)':
        return 'US/Pacific';
      case 'Mountain Time (US & Canada)':
        return 'US/Mountain';
      case 'Central Time (US & Canada)':
        return 'US/Central';
      case 'Atlantic Time (Canada)':
        return 'Canada/Atlantic';
      case 'Newfoundland':
        return 'Canada/Newfoundland';
      case 'Dublin':
        return 'Europe/Dublin';
      case 'London':
        return 'Europe/London';
      case 'Lisbon':
        return 'Europe/Lisbon';
      case 'Madrid':
        return 'Europe/Madrid';
      case 'Portugal':
        return 'Europe/Lisbon';
      case 'Perth':
        return 'Australia/Perth';
      case 'Darwin':
        return 'Australia/Darwin';
      case 'Brisbane':
        return 'Australia/Brisbane';
      case 'Adelaide':
        return 'Australia/Adelaide';
      case 'Sydney':
        return 'Australia/Sydney';
      default:
        return timezone;
    }
  }

  getTimezones(
    country: 'US' | 'CA' | 'UK' | 'Spain' | 'Australia' | 'UEA' | 'ALL' = 'US'
  ): string[] {
    const timezones = {
      US: [
        ['Eastern Time', 'Eastern Time (US & Canada)'],
        ['Alaska Time', 'Alaska'],
        ['Hawaii-Aleutian Time', 'Hawaii'],
        ['Pacific Time', 'Pacific Time (US & Canada)'],
        ['Mountain Time', 'Mountain Time (US & Canada)'],
        ['Central Time', 'Central Time (US & Canada)'],
        ['Arizona', 'Mountain Time (US & Canada)'],
      ],
      CA: [
        ['Pacific Time', 'Pacific Time (US & Canada)'],
        ['Mountain Time', 'Mountain Time (US & Canada)'],
        ['Central Time', 'Central Time (US & Canada)'],
        ['Eastern Time', 'Eastern Time (US & Canada)'],
        ['Atlantic Time', 'Atlantic Time (Canada)'],
        ['Newfoundland Time', 'Newfoundland'],
      ],
      UK: [
        ['Greenwich Time', 'Dublin'],
        ['Falkland Islands Time', 'Atlantic/Stanley'],
        ['South Georgia Time', 'Atlantic/South_Georgia'],
        ['Atlantic Time', 'America/Anguilla'],
        ['Pitcairn Standard Time', 'Pacific/Pitcairn'],
        ['Central European Standard Time', 'Europe/Amsterdam'],
        ['Eastern European Standard Time', 'Europe/Athens'],
        ['Eastern Time', 'America/Grand_Turk'],
        ['British Summer Time', 'London'],
        ['Western European Time', 'Lisbon'],
      ],
      Spain: [
        ['Central Time', 'Madrid'],
        ['Western Time', 'Portugal'],
      ],
      Australia: [
        ['Australian Western Time', 'Perth'],
        ['Australian Central Standard Time', 'Darwin'],
        ['Australian Eastern Time', 'Brisbane'],
        ['Australian Central Daylight Time', 'Adelaide'],
        ['Australian Eastern Daylight Time', 'Sydney'],
        ['Lord Howe Daylight Time', 'Australia/Lord_Howe'],
        ['Australian Central Western Time', 'Australia/Eucla'],
      ],
      UAE: [['Gulf Time', 'Asia/Dubai']],
    };

    if (country !== 'ALL') {
      return timezones[country];
    }

    const result = [];
    Object.keys(timezones).forEach(zone => {
      timezones[zone].forEach(item => {
        result.push(item[1]);
      });
    });

    return result;
  }

  getStates() {
    return {
      US: {
        AL: 'Alabama',
        AK: 'Alaska',
        AZ: 'Arizona',
        AR: 'Arkansas',
        CA: 'California',
        CO: 'Colorado',
        CT: 'Connecticut',
        DE: 'Delaware',
        DC: 'District of Columbia',
        FL: 'Florida',
        GA: 'Georgia',
        HI: 'Hawaii',
        ID: 'Idaho',
        IL: 'Illinois',
        IN: 'Indiana',
        IA: 'Iowa',
        KS: 'Kansas',
        KY: 'Kentucky',
        LA: 'Louisiana',
        ME: 'Maine',
        MD: 'Maryland',
        MA: 'Massachusetts',
        MI: 'Michigan',
        MN: 'Minnesota',
        MS: 'Mississippi',
        MO: 'Missouri',
        MT: 'Montana',
        NE: 'Nebraska',
        NV: 'Nevada',
        NH: 'New Hampshire',
        NJ: 'New Jersey',
        NM: 'New Mexico',
        NY: 'New York',
        NC: 'North Carolina',
        ND: 'North Dakota',
        OH: 'Ohio',
        OK: 'Oklahoma',
        OR: 'Oregon',
        PA: 'Pennsylvania',
        PR: 'Puerto Rico',
        RI: 'Rhode Island',
        SC: 'South Carolina',
        SD: 'South Dakota',
        TN: 'Tennessee',
        TX: 'Texas',
        UT: 'Utah',
        VT: 'Vermont',
        VA: 'Virginia',
        WA: 'Washington',
        WV: 'West Virginia',
        WI: 'Wisconsin',
        WY: 'Wyoming',
      },
      CA: {
        AB: 'Alberta',
        BC: 'British Columbia',
        MB: 'Manitoba',
        NB: 'New Brunswick',
        NL: 'Newfoundland and Labrador',
        NT: 'Northwest Territories',
        NS: 'Nova Scotia',
        NU: 'Nunavut',
        ON: 'Ontario',
        PE: 'Prince Edward Island',
        QC: 'Quebec',
        SK: 'Saskatchewan',
        YT: 'Yukon',
      },
      CI: {
        CI: 'Cayman Islands',
      },
      UK: {
        Sheffield: 'Sheffield',
        'West Sussex': 'West Sussex'
      },
      AU: {
        NSW: 'New South Wales',
        VIC: 'Victoria',
      },
    };
  }

  getCountries() {
    return {
      US: 'United States',
      CA: 'Canada',
    };
  }

  getCountryItems(): ISelectItem[] {
    return [
      {
        label: 'United States',
        value: 'US',
      },
      {
        label: 'Canada',
        value: 'CA',
      },
    ];
  }}
